<script lang="ts">
  export let active: boolean = false;
  const toggleClick = () => (active = !active);
</script>

<div class="flex items-center justify-center rounded-full {active ? 'bg-neutral' : 'bg-slate-300'}">
  <div
    class="relative h-4 w-8 cursor-pointer rounded-full outline outline-4 transition-all {active
      ? 'bg-neutral outline-neutral'
      : 'bg-slate-300 outline-slate-300'}"
    on:click={toggleClick}
  >
    <div class="absolute h-4 w-4 transform rounded-full bg-white transition-all {active ? ' translate-x-full' : ''}" />
  </div>
</div>
